import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BillingSettingsService } from "../settings/billing-settings.service";
import { ToastrService } from "../../shared/toastr.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-cancel",
  templateUrl: "./cancel.component.html",
  styleUrls: ["./cancel.component.scss"],
  standalone: false,
})
export class BillingCancelComponent implements OnInit {
  isRetryingPayment = false;

  constructor(
    private router: Router,
    private billingSettingsService: BillingSettingsService,
    private toastr: ToastrService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.translate
      .get("settings.billing.cancel.paymentCancelledAlert")
      .subscribe((translation: string) => {
        this.toastr.info(translation);
      });
  }

  retryPayment(): void {
    this.isRetryingPayment = true;
    this.billingSettingsService.createCheckoutSession().subscribe({
      next: (response: { url: string }) => {
        window.location.href = response.url;
      },
      error: () => {
        this.toastr.error(
          this.translate.instant("settings.billing.paymentError") as string,
        );
        this.isRetryingPayment = false;
      },
    });
  }

  backToBilling(): void {
    void this.router.navigate(["/settings/billing"]);
  }
}
